import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;
const getCurrentStockDataList = (page, pagesize, search, ordering) => {
  return axios.get(
    `${API_URL}/api/${API_VERSION}/warehouse-current-stock/party-wise-stock-summery`,
    {
      headers: authHeader(),
      params: {
        deleted: 0,
        page: page,
        pagesize: pagesize,
        search: search, // You might want to include search here, if applicable
        ordering: ordering,
      },
    },
  );
};
const getCurrentStockDataItemList = (page, pagesize, search, ordering) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/warehouse-current-stock/all-dispatched-bundles/`,
    {
      headers: authHeader(),
      params: {
        deleted: 0,
        page: page,
        pagesize: pagesize,
        search: search, // You might want to include search here, if applicable
        ordering: ordering,
      },
    },
  );
};
const getCurrentStockItemWiseSummary = (page, pagesize, search, ordering) => {
  return axios.get(
    `${API_URL}/api/${API_VERSION}/warehouse-current-stock/warehouse-item-wise-stock-summary/`,
    {
      headers: authHeader(),
      params: {
        deleted: 0,
        page: page,
        pagesize: pagesize,
        search: search,
        ordering: ordering,
      },
    },
  );
};

const getCurrentStockByCompanyId = (page, pagesize, search, ordering, id) => {
  return axios.get(
    `${API_URL}/api/${API_VERSION}/warehouse-current-stock/workorders/${id}`,
    {
      headers: authHeader(),
      params: {
        deleted: 0,
        page: page,
        pagesize: pagesize,
        search: search, // You might want to include search here, if applicable
        ordering: ordering,
      },
    },
  );
};
const getCurrentStockByCompanyIdDetails = (
  page,
  pagesize,
  search,
  ordering,
  id,
) => {
  return axios.get(
    `${API_URL}/api/${API_VERSION}/warehouse-current-stock/warehouse-packed-bundles/${id}`,
    {
      headers: authHeader(),
      params: {
        deleted: 0,
        page: page,
        pagesize: pagesize,
        search: search, // You might want to include search here, if applicable
        ordering: ordering,
      },
    },
  );
};
const deleteCurrentStockList = id => {
  return axios.delete(
    `${API_URL}/api/${API_VERSION}/bundle-inward/delete-bundle/${id}/`, // Include `id` in the URL
    {
      headers: {
        ...authHeader(),
        'Content-Type': 'multipart/form-data', // Ensure proper header for FormData
      },
    },
  );
};
const warehouseService = {
  getCurrentStockDataList,
  deleteCurrentStockList,
  getCurrentStockByCompanyId,
  getCurrentStockByCompanyIdDetails,
  getCurrentStockDataItemList,
  getCurrentStockItemWiseSummary,
};

export default warehouseService;
